module.exports = __webpack_public_path__ + "static/img/bcg_s.3b230efc.png";